import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, tap } from 'rxjs/operators';

import { LanguageService } from '@fcom/ui-translate';
import { ScrollService } from '@fcom/common/services';
import { RootPaths } from '@fcom/core/constants';

import { StatusActions } from '../actions';
import { Stage } from '../../interfaces/stage.interface';

@Injectable()
export class StatusEffects {
  navigate(path: string): void {
    this.router.navigate(['/', this.lang.langValue || 'en', ...RootPaths.ONE_UPGRADE_ROOT.split('/'), path]);
  }

  stage$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(StatusActions.setStage.type),
        map((action) => action.stage),
        tap((stage) => {
          switch (stage) {
            case Stage.LOGIN: {
              this.router.navigate(['/', this.lang.langValue || 'en', ...RootPaths.ONE_UPGRADE_ROOT.split('/')], {
                queryParamsHandling: 'merge',
              });
              this.scrollService.scrollTop();
              return;
            }
            case Stage.LOADING:
              this.navigate('loading');
              this.scrollService.scrollTop();
              return;
            case Stage.PASSENGERS:
              this.navigate('passengers');
              this.scrollService.scrollTop();
              return;
            case Stage.FLIGHTS: {
              this.navigate('flights');
              this.scrollService.scrollTop();
              return;
            }
            case Stage.REVIEW: {
              this.navigate('review');
              this.scrollService.scrollTop();
              return;
            }
            case Stage.SUCCESS: {
              this.navigate('success');
              this.scrollService.scrollTop();
              return;
            }
            case Stage.PROCESSING: {
              this.router.navigate([
                '/',
                this.lang.langValue || 'en',
                ...RootPaths.ONE_UPGRADE_ROOT.split('/'),
                'processing',
              ]);
              this.scrollService.scrollTop();
              return;
            }
            case Stage.ERROR: {
              this.navigate('error');
              this.scrollService.scrollTop();
              return;
            }
            default: {
              return;
            }
          }
        })
      ),
    { dispatch: false }
  );

  constructor(
    private readonly actions$: Actions<StatusActions.StatusActionsUnion>,
    private router: Router,
    private lang: LanguageService,
    private scrollService: ScrollService
  ) {}
}
